import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import i18n from "src/i18n/i18n";
import {
  DEFAULT_LOCALE,
  isRtl,
  SupportedLocale,
} from "src/i18n/constants";

export interface LocaleState {
  currentLocale: SupportedLocale;
}

const initialState: LocaleState = {
  currentLocale: DEFAULT_LOCALE,
};

const localeSlice = createSlice({
  name: "locale",
  initialState,
  reducers: {
    setLocale(state, action: PayloadAction<SupportedLocale>) {
      const locale = action.payload;
      state.currentLocale = locale;

      i18n.changeLanguage(locale);
      document.documentElement.lang = locale;
      document.documentElement.dir = isRtl(locale) ? "rtl" : "ltr";
    },
  },
});

export const { setLocale } = localeSlice.actions;

export const selectLocale = (state: { locale: LocaleState }): SupportedLocale =>
  state.locale.currentLocale;

/**
 * Initialize the locale from the employee's preferred_language after login.
 * If the employee has a preferred_language set, dispatch setLocale() to apply it.
 */
export function initLocaleFromEmployee(preferredLanguage: string | null) {
  return (dispatch: (action: ReturnType<typeof setLocale>) => void) => {
    if (preferredLanguage) {
      dispatch(setLocale(preferredLanguage as SupportedLocale));
    }
  };
}

export default localeSlice.reducer;
